import React, {lazy} from 'react';
import Page1 from "./Page1";
import Page2 from "./Page2";
import Login from './login/Login'
import EditPassword from './editPassword/EditPassword'
import Signature from './signature'
import Main from './main'
import Demo from './demo'
import WebsocketDemo from "@pages/demo/WebsocketDemo";
import Phone from "@/Phone";


const Casepool = React.lazy(() => import('./casepool'));
const CaseRegister = React.lazy(() => import('./caseRegister'));
const CaseDetail = React.lazy(() => import('./caseDetail'));

export const CASEPOOLURL = '/fagicCourt/casepool';
export const CASEROUTER = '/fagicCourt/caseRegister';
export const DETAILURL = '/fagicCourt/detail';

export const routeMap = [
    {
        path: "/page1",
        Component: Page1 ,
    },
    {
        path: "/page2",
        Component: Page2,
    },
    {
        path: "/login",
        Component: Login,
    },
    {
        path: "/editPassword",
        Component: EditPassword,
    },
    {
        path: "/phone",
        Component: Phone,
    },
    {
        path: "/fagicCourt",
        Component: Main,
    },
    {
        path: "/demo",
        Component: WebsocketDemo,
    },
    {
        path: "/InternetCourt/signature",
        Component: Signature,
    }
];

export const contentRoutes = [
    {
        path: CASEPOOLURL,
        Component: Casepool,
    },
    {
        path: CASEROUTER,
        Component: CaseRegister,
    },
    {
        path: DETAILURL,
        Component: CaseDetail ,
    },
];
